import _ from 'lodash';

export const renderImports = imps => !_.isEmpty(imps) ? imps.join('\n') + '\n' : '';
